function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PokerUI = /*#__PURE__*/function () {
  function PokerUI() {
    _classCallCheck(this, PokerUI);
  }
  return _createClass(PokerUI, [{
    key: "returnPlayerRole",
    value: function returnPlayerRole(player) {
      if (this.game.state.winners.length > 0) {
        if (this.game.state.winners.includes(player)) {
          return 'Winner!';
        }
      }
      if (player == this.game.state.button_player && player == this.game.state.small_blind_player) {
        return 'dealer / small blind';
      }
      if (player == this.game.state.button_player) {
        return 'dealer';
      }
      if (player == this.game.state.small_blind_player) {
        return 'small blind';
      }
      if (player == this.game.state.big_blind_player) {
        return 'big blind';
      }
      return '';
    }
  }, {
    key: "displayPlayers",
    value: function displayPlayers() {
      var preserveLog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.browser_active) {
        return;
      }
      for (var i = 1; i <= this.game.players.length; i++) {
        this.playerbox.updateUserline(this.returnPlayerRole(i), i);
        this.displayPlayerStack(i);
        if (!preserveLog) {
          this.displayPlayerNotice("<div class=\"plog-update\"></div>", i);
        }
      }
    }
  }, {
    key: "clearPlayers",
    value: function clearPlayers() {
      //
      // clear displayed cards... / button / player-pots
      //
      for (var i = 1; i <= this.game.players.length; i++) {
        this.playerbox.updateGraphics('', i);
      }
    }
  }, {
    key: "refreshPlayerboxes",
    value: function refreshPlayerboxes() {
      this.playerbox.removeBoxes();
      this.playerbox.render();
      this.displayPlayerNotice((this === null || this === void 0 ? void 0 : this.status) || '', this.game.player);
      $('.game-playerbox-seat-1').appendTo('.mystuff');
      if (this.game.player == 0) {
        this.observerControls.render();
      } else {
        this.observerControls.remove();
      }
    }
  }, {
    key: "displayButton",
    value: function displayButton() {
      for (var i = 1; i <= this.game.players.length; i++) {
        if (i == this.game.state.button_player) {
          this.playerbox.updateGraphics("<div class=\"dealer-button\" title=\"dealer button\">D</div>", i);
        } else {
          this.playerbox.updateGraphics('', i);
        }

        /*if (this.game.state.player_pot[i - 1] && !this.loadGamePreference('poker-hide-pot')) {
          let html = `<div class="poker-player-stake"><span class="stake-in-chips">${this.game.state.player_pot[i - 1]}</span></div>`;
          this.playerbox.replaceGraphics(html, '.poker-player-stake', i);
        }*/
      }
    }
  }, {
    key: "displayHand",
    value: function displayHand() {
      if (this.game.player == 0) {
        this.updateStatus("you are observing the game", -1);
        return;
      }
      if (this.game.state.passed[this.game.player - 1]) {
        this.cardfan.hide();
      } else {
        this.cardfan.render();
      }
    }
  }, {
    key: "showPlayerHand",
    value: function showPlayerHand(player, card1, card2) {
      if (!this.gameBrowserActive()) {
        return;
      }
      var playercards = "<div class=\"other-player-hand hand\">\n                    <div class=\"card\"><img src=\"".concat(this.card_img_dir, "/").concat(this.game.deck[0].cards[card1].name, "\"></div>\n                    <div class=\"card\"><img src=\"").concat(this.card_img_dir, "/").concat(this.game.deck[0].cards[card2].name, "\"></div>\n                  </div>\n                ");
      this.playerbox.updateGraphics(playercards, player);
    }

    //
    // Updates the status / text information body of player box
    //
  }, {
    key: "displayPlayerNotice",
    value: function displayPlayerNotice(msg, player) {
      if (!player) {
        return;
      }
      if (player == this.game.player) {
        this.playerbox.updateBody("<div class=\"status\" id=\"status\"></div><div class=\"controls\" id=\"controls\"></div>", player);
        this.updateStatus(msg);
      } else {
        this.playerbox.updateBody(msg, player);
      }
      console.log('displayPlayerNotice:', msg);
    }

    // Update the player's role and wager...
  }, {
    key: "displayPlayerStack",
    value: function displayPlayerStack(player) {
      var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      if (!this.browser_active) {
        return;
      }
      if (amount === -1) {
        amount = this.game.state.player_credit[player - 1];
      }
      var credit = this.convertChipsToCrypto(amount);

      //
      // Amount = number of chips in player stack, credit = crypto value of chips in player stack
      //

      var chips = 'CHIP';
      if (amount !== 1) {
        chips += 'S';
      }
      var stack_html = stack_html = "<div class=\"poker-stack-balance\">".concat(amount, "</div><div class=\"poker-stack-units\">").concat(chips, "</div>");
      if (typeof this.game.stake === 'string' && this.game.crypto !== 'CHIPS') {
        // Could add a test for an option to should crypto by default (either globally or just a toggle here)
        stack_html += "<div class=\"crypto-hover-balance\">".concat(credit, " <span class=\"smaller-font\">").concat(this.game.crypto, "</span></div>");
      }
      this.playerbox.updateIcons(stack_html, player);
    }

    //
    // We will actually increment player stack / decrement the game pot in this function!!!
    //
  }, {
    key: "animateWin",
    value: function () {
      var _animateWin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(amount, winners) {
        var _this = this;
        var step_speed, _loop, j, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.animating = true;
              step_speed = Math.min(200, 1000 / amount);
            case 1:
              if (!(amount >= Object.keys(winners).length && this.animating)) {
                _context2.n = 5;
                break;
              }
              _loop = /*#__PURE__*/_regenerator().m(function _loop(j) {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      j = parseInt(j);
                      _this.moveGameElement(_this.createGameElement("<div class=\"poker-chip\"></div>", '.pot'), ".game-playerbox-".concat(j + 1), {
                        callback: function callback() {
                          _this.pot.render(Math.max(0, --amount));
                          _this.displayPlayerStack(j + 1, ++winners[j]);
                        },
                        run_all_callbacks: true
                      }, function (item) {
                        $(item).remove();
                      });
                      _context.n = 1;
                      return _this.timeout(step_speed);
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(winners);
            case 2:
              if ((_t2 = _t()).done) {
                _context2.n = 4;
                break;
              }
              j = _t2.value;
              return _context2.d(_regeneratorValues(_loop(j)), 3);
            case 3:
              _context2.n = 2;
              break;
            case 4:
              _context2.n = 1;
              break;
            case 5:
              if (amount > 0) {
                // ***TO DO: examine possibility of fractional chips
                // Randomly give the remaining chip to one player
              }
            case 6:
              return _context2.a(2);
          }
        }, _callee, this);
      }));
      function animateWin(_x, _x2) {
        return _animateWin.apply(this, arguments);
      }
      return animateWin;
    }()
  }, {
    key: "animateBet",
    value: function () {
      var _animateBet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(better, amount) {
        var _this2 = this;
        var restartQueue,
          initial_pot,
          initial_stack,
          step_speed,
          qs,
          i,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              restartQueue = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              if (restartQueue) {
                this.halted = 1;
              }
              initial_pot = this.pot.render();
              initial_stack = this.game.state.player_credit[better - 1];
              step_speed = Math.min(150, 550 / amount);
              i = 1;
            case 1:
              if (!(i <= amount)) {
                _context3.n = 3;
                break;
              }
              this.moveGameElement(this.createGameElement("<div class=\"poker-chip\"></div>", ".game-playerbox-".concat(better)), '.pot', {
                callback: function callback() {
                  _this2.pot.render(++initial_pot);
                  _this2.displayPlayerStack(better, --initial_stack);
                  // player_pot is update outside the animation...
                  /*qs = this.playerbox.replaceGraphics(
                    `<div class="poker-player-stake"><span class="stake-in-chips">${this.game.state.player_pot[better - 1] + i}</span></div>`,
                    '.poker-player-stake',
                    better
                  );*/
                  _this2.pot.addPulse();
                },
                run_all_callbacks: true
              }, function (item) {
                /*if (this.loadGamePreference('poker-hide-pot')) {
                  setTimeout(() => {
                    document.querySelector(qs).classList.add('invisible');
                  }, 500);
                }*/

                if (!restartQueue) {
                  $(item).remove();
                } else {
                  $('.animated_elem').remove();
                  _this2.restartQueue();
                }
              });
              _context3.n = 2;
              return this.timeout(step_speed);
            case 2:
              i++;
              _context3.n = 1;
              break;
            case 3:
              _context3.n = 4;
              return this.timeout(500);
            case 4:
              return _context3.a(2);
          }
        }, _callee2, this);
      }));
      function animateBet(_x3, _x4) {
        return _animateBet.apply(this, arguments);
      }
      return animateBet;
    }()
    /*
    This is the core Poker function
    */
  }, {
    key: "playerTurn",
    value: function playerTurn() {
      var _this3 = this;
      if (this.browser_active == 0) {
        return;
      }
      if (this.game.player == 0) {
        salert('How on earth did we call player-zero turn??');
        return;
      }
      var poker_self = this;

      //
      // cancel raise kicks us back
      //
      if (!poker_self.moves.includes('resolve\tturn')) {
        poker_self.addMove('resolve\tturn');
      }
      var match_required = this.game.state.required_pot - this.game.state.player_pot[this.game.player - 1];
      if (match_required == 0 && this.game.state.all_in) {
        poker_self.addMove("allin");
        poker_self.endTurn();
        return;
      }
      if (match_required < 0) {
        console.warn('Hmmm, can bet negative chips');
        match_required = 0;
      }

      //These would be a strange edge case
      this.game.state.last_raise = Math.max(this.game.state.last_raise, this.game.state.big_blind);
      var can_call = this.game.state.player_credit[this.game.player - 1] >= match_required;
      var can_raise = !this.game.state.all_in && this.game.state.player_credit[this.game.player - 1] > match_required;

      //cannot raise more than everyone can call.
      //
      // TODO - buy-ins will change this smallest stack calculation
      //
      var smallest_stack = this.game.chips * poker_self.game.players.length; //Start with total amount of money in the game
      var smallest_stack_player = 0;
      poker_self.game.state.player_credit.forEach(function (stack, index) {
        if (poker_self.game.state.passed[index] == 0) {
          stack += _this3.game.state.player_pot[index];
          stack -= _this3.game.state.required_pot;
          if (stack < smallest_stack) {
            smallest_stack = stack;
            smallest_stack_player = index;
          }
        }
      });
      if (!can_call) {
        this.updateStatus('you can only fold...');
        this.addMove('fold\t' + poker_self.game.player);
        this.endTurn();
        return;
      }

      // Makes sure the controls are available and updates status
      this.displayPlayerNotice("".concat(this.formatWager(this.game.state.player_pot[this.game.player - 1]), " in pot"), this.game.player);
      var html = '<div class="option" id="fold"><img src="/poker/img/fold_icon.svg" alt="fold"><span>fold</span></div>';
      if (match_required > 0) {
        html += "<div class=\"option\" id=\"call\"><img src=\"/poker/img/call_icon.svg\" alt=\"call\"><span>call <span class=\"call-wager\">(".concat(this.formatWager(match_required, false), ")</span></span></div>");
      } else {
        // we don't NEED to match
        html += '<div class="option" id="check"><img src="/poker/img/check_icon.svg" alt="check"><span>check</span></div>';
      }
      if (can_raise) {
        html += "<div class=\"option\" id=\"raise\"><img src=\"/poker/img/raise_icon.svg\" alt=\"raise\"><span>raise</span></div>";
      }
      this.updateControls(html);
      $('.option').off();
      $('.option').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var choice, credit_remaining, max_raise, i, this_raise, _enterRaise, c;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              choice = $(this).attr('id');
              if (!(choice === 'raise')) {
                _context6.n = 5;
                break;
              }
              credit_remaining = poker_self.game.state.player_credit[poker_self.game.player - 1] - match_required;
              html = "<div class=\"option raise_option\" id=\"0\"><img src=\"/poker/img/cancel_raise_icon.svg\" alt=\"cancel\"></div>";
              if (match_required > 0) {
                html += "match ".concat(poker_self.formatWager(match_required), " and  ");
              }
              html += "raise";
              poker_self.updateStatus(html);
              max_raise = Math.min(credit_remaining, smallest_stack);
              html = '';
              i = 0;
            case 1:
              if (!(i < 3)) {
                _context6.n = 4;
                break;
              }
              this_raise = poker_self.game.state.last_raise * Math.pow(2, i);
              if (!(max_raise > this_raise)) {
                _context6.n = 2;
                break;
              }
              html += "<div class=\"option raise_option\" id=\"".concat(this_raise + match_required, "\"><img src=\"/poker/img/raise_value_icon.svg\" alt=\"raise\">");
              html += poker_self.formatWager(this_raise, false);
              if (typeof poker_self.game.stake === 'string' && poker_self.game.crypto !== 'CHIPS') {
                html += "<div class=\"crypto-hover-raise\">".concat(poker_self.convertChipsToCrypto(this_raise), " <span class=\"smaller-font\"> ").concat(poker_self.game.crypto, "</span></div>");
              }
              html += '</div>';
              _context6.n = 3;
              break;
            case 2:
              return _context6.a(3, 4);
            case 3:
              i++;
              _context6.n = 1;
              break;
            case 4:
              //Option for manual input...
              html += "<div class=\"option raise_option\" id=\"manual\"><img src=\"/poker/img/raise_allin_icon.svg\" alt=\"raise\"><span>?</span></div>";

              //Always give option for all in
              html += "<div class=\"option raise_option all-in\" id=\"".concat(max_raise + match_required, "\"><img src=\"/poker/img/raise_allin_icon.svg\" alt=\"raise\">");
              html += poker_self.formatWager(max_raise, false);
              if (typeof poker_self.game.stake === 'string' && poker_self.game.crypto !== 'CHIPS') {
                html += "<div class=\"crypto-hover-raise\">".concat(poker_self.convertChipsToCrypto(max_raise), " <span class=\"smaller-font\"> ").concat(poker_self.game.crypto, "</span></div>");
              }
              html += "</div>";
              poker_self.updateControls(html);
              _enterRaise = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var c, amt;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        _context4.n = 1;
                        return sprompt('How many chips would you like to raise?');
                      case 1:
                        c = _context4.v;
                        if (!c) {
                          _context4.n = 4;
                          break;
                        }
                        amt = parseInt(c);
                        if (!(amt >= poker_self.game.state.last_raise && amt <= max_raise)) {
                          _context4.n = 2;
                          break;
                        }
                        poker_self.addMove("raise\t".concat(poker_self.game.player, "\t").concat(amt + match_required));
                        poker_self.endTurn();
                        _context4.n = 4;
                        break;
                      case 2:
                        _context4.n = 3;
                        return sconfirm('Invalid input');
                      case 3:
                        _enterRaise();
                      case 4:
                        return _context4.a(2);
                    }
                  }, _callee3);
                }));
                return function enterRaise() {
                  return _ref2.apply(this, arguments);
                };
              }();
              $('.option').off();
              $('.option').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var raise;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      raise = $(this).attr('id');
                      if (raise === '0') {
                        poker_self.playerTurn();
                      } else if (raise === 'manual') {
                        _enterRaise();
                      } else {
                        poker_self.addMove("raise\t".concat(poker_self.game.player, "\t").concat(raise));
                        poker_self.endTurn();
                      }
                    case 1:
                      return _context5.a(2);
                  }
                }, _callee4, this);
              })));
              _context6.n = 8;
              break;
            case 5:
              if (!(choice == 'fold' && !match_required)) {
                _context6.n = 7;
                break;
              }
              _context6.n = 6;
              return sconfirm('Are you sure you want to fold?');
            case 6:
              c = _context6.v;
              if (c) {
                _context6.n = 7;
                break;
              }
              poker_self.playerTurn();
              return _context6.a(2);
            case 7:
              poker_self.addMove("".concat(choice, "\t").concat(poker_self.game.player));
              poker_self.endTurn();
            case 8:
              return _context6.a(2);
          }
        }, _callee5, this);
      })));
    }
  }]);
}();
module.exports = PokerUI;